import isReachable from 'is-reachable';

/**
 * Verifica si una dirección IP o host es alcanzable.
 * En el navegador, utiliza un método basado en tiempos de respuesta para evadir restricciones de CORS.
 * @param ip Dirección IP o Hostname a verificar.
 * @returns Promesa que resuelve a true si es alcanzable, false si no.
 */
export default async function CheckIP(ip: string): Promise<boolean> {
    //  console.log("Ejecutando CheckIP para:", ip);

    // Si estamos en el navegador (React)
    if (typeof window !== 'undefined') {
        const startTime = Date.now();
        return new Promise((resolve) => {
            const timeout = 2500; // Valor estable para VPN
            let finished = false;

            const timer = setTimeout(() => {
                if (!finished) {
                    finished = true;
                    const elapsed = Date.now() - startTime;
                    //   console.log(`[CheckIP] TIMEOUT: No se obtuvo respuesta de ${ip} tras ${elapsed}ms`);
                    resolve(false);
                }
            }, timeout);

            const img = new Image();

            const handleFinish = (status: boolean, msg: string) => {
                if (!finished) {
                    finished = true;
                    clearTimeout(timer);
                    const elapsed = Date.now() - startTime;
                    //   console.log(`[CheckIP] ${msg} para ${ip} en ${elapsed}ms -> Alcanzable: ${status}`);
                    resolve(status);
                }
            };

            img.onload = () => handleFinish(true, "RESPUESTA_OK");
            img.onerror = () => handleFinish(true, "RESPUESTA_RAPIDA_ERROR");

            const targetUrl = ip.startsWith('http') ? ip : `https://${ip}`;
            img.src = `${targetUrl}/favicon.ico?v=${Date.now()}`;
        });
    }

    // Lógica para Node.js (Pruebas de terminal)
    let Resultado: boolean = false;
    try {
        Resultado = await isReachable(ip);
    } catch (error) {
        //   console.error("Error en CheckIP [Node]:", error);
        Resultado = false;
    }
    //  console.log("Resultado CheckIP [Node]:", Resultado);
    return Resultado;
}
